const optionsCountries = [
    { "country": "Alemania", "country_EN": "Germany", "code": "+49" },
    { "country": "Arabia Saudita", "country_EN": "Saudi Arabia", "code": "+966" },
    { "country": "Argentina", "country_EN": "Argentina", "code": "+54" },
    { "country": "Australia", "country_EN": "Australia", "code": "+61" },
    { "country": "Bahrein", "country_EN": "Bahrain", "code": "+973" },
    { "country": "Bangladés", "country_EN": "Bangladesh", "code": "+880" },
    { "country": "Bélgica", "country_EN": "Belgium", "code": "+32" },
    { "country": "Bolivia", "country_EN": "Bolivia", "code": "+591" },
    { "country": "Brasil", "country_EN": "Brazil", "code": "+55" },
    { "country": "Camerún", "country_EN": "Cameroon", "code": "+237" },
    { "country": "Canadá", "country_EN": "Canada", "code": "+1" },
    { "country": "Catar", "country_EN": "Qatar", "code": "+974" },
    { "country": "Chile", "country_EN": "Chile", "code": "+56" },
    { "country": "China", "country_EN": "China", "code": "+86" },
    { "country": "Colombia", "country_EN": "Colombia", "code": "+57" },
    { "country": "Corea del Sur", "country_EN": "South Korea", "code": "+82" },
    { "country": "Costa de Marfil", "country_EN": "Ivory Coast", "code": "+225" },
    { "country": "Costa Rica", "country_EN": "Costa Rica", "code": "+506" },
    { "country": "Cuba", "country_EN": "Cuba", "code": "+53" },
    { "country": "Ecuador", "country_EN": "Ecuador", "code": "+593" },
    { "country": "Egipto", "country_EN": "Egypt", "code": "+20" },
    { "country": "Emiratos Árabes Unidos", "country_EN": "United Arab Emirates", "code": "+971" },
    { "country": "España", "country_EN": "Spain", "code": "+34" },
    { "country": "Estados Unidos", "country_EN": "United States", "code": "+1" },
    { "country": "Filipinas", "country_EN": "Philippines", "code": "+63" },
    { "country": "Fiji", "country_EN": "Fiji", "code": "+679" },
    { "country": "Francia", "country_EN": "France", "code": "+33" },
    { "country": "Ghana", "country_EN": "Ghana", "code": "+233" },
    { "country": "Grecia", "country_EN": "Greece", "code": "+30" },
    { "country": "India", "country_EN": "India", "code": "+91" },
    { "country": "Indonesia", "country_EN": "Indonesia", "code": "+62" },
    { "country": "Irán", "country_EN": "Iran", "code": "+98" },
    { "country": "Iraq", "country_EN": "Iraq", "code": "+964" },
    { "country": "Israel", "country_EN": "Israel", "code": "+972" },
    { "country": "Italia", "country_EN": "Italy", "code": "+39" },
    { "country": "Japón", "country_EN": "Japan", "code": "+81" },
    { "country": "Jordania", "country_EN": "Jordan", "code": "+962" },
    { "country": "Kenia", "country_EN": "Kenya", "code": "+254" },
    { "country": "Kuwait", "country_EN": "Kuwait", "code": "+965" },
    { "country": "Líbano", "country_EN": "Lebanon", "code": "+961" },
    { "country": "Libia", "country_EN": "Libya", "code": "+218" },
    { "country": "Malasia", "country_EN": "Malaysia", "code": "+60" },
    { "country": "Marruecos", "country_EN": "Morocco", "code": "+212" },
    { "country": "México", "country_EN": "Mexico", "code": "+52" },
    { "country": "Nigeria", "country_EN": "Nigeria", "code": "+234" },
    { "country": "Noruega", "country_EN": "Norway", "code": "+47" },
    { "country": "Nueva Zelanda", "country_EN": "New Zealand", "code": "+64" },
    { "country": "Omán", "country_EN": "Oman", "code": "+968" },
    { "country": "Pakistán", "country_EN": "Pakistan", "code": "+92" },
    { "country": "Panamá", "country_EN": "Panama", "code": "+507" },
    { "country": "Papúa Nueva Guinea", "country_EN": "Papua New Guinea", "code": "+675" },
    { "country": "Países Bajos", "country_EN": "Netherlands", "code": "+31" },
    { "country": "Perú", "country_EN": "Peru", "code": "+51" },
    { "country": "Polonia", "country_EN": "Poland", "code": "+48" },
    { "country": "Portugal", "country_EN": "Portugal", "code": "+351" },
    { "country": "Reino Unido", "country_EN": "United Kingdom", "code": "+44" },
    { "country": "Rumania", "country_EN": "Romania", "code": "+40" },
    { "country": "Rusia", "country_EN": "Russia", "code": "+7" },
    { "country": "Senegal", "country_EN": "Senegal", "code": "+221" },
    { "country": "Singapur", "country_EN": "Singapore", "code": "+65" },
    { "country": "Sudáfrica", "country_EN": "South Africa", "code": "+27" },
    { "country": "Sudán", "country_EN": "Sudan", "code": "+249" },
    { "country": "Suecia", "country_EN": "Sweden", "code": "+46" },
    { "country": "Tailandia", "country_EN": "Thailand", "code": "+66" },
    { "country": "Tanzania", "country_EN": "Tanzania", "code": "+255" },
    { "country": "Tonga", "country_EN": "Tonga", "code": "+676" },
    { "country": "Turquía", "country_EN": "Turkey", "code": "+90" },
    { "country": "Túnez", "country_EN": "Tunisia", "code": "+216" },
    { "country": "Ucrania", "country_EN": "Ukraine", "code": "+380" },
    { "country": "Uganda", "country_EN": "Uganda", "code": "+256" },
    { "country": "Uruguay", "country_EN": "Uruguay", "code": "+598" },
    { "country": "Venezuela", "country_EN": "Venezuela", "code": "+58" },
    { "country": "Vietnam", "country_EN": "Vietnam", "code": "+84" },
    { "country": "Yemen", "country_EN": "Yemen", "code": "+967" }
];

export default optionsCountries;